export default "__VITE_ASSET__Db75OdBY__"